import { render, staticRenderFns } from "./ResTrSubstations.vue?vue&type=template&id=5f5bb333&scoped=true"
import script from "./ResTrSubstations.vue?vue&type=script&lang=js"
export * from "./ResTrSubstations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5bb333",
  null
  
)

export default component.exports